import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import Problem from './components/Problem';
import Solution from './components/Solution';
import Features from './components/Features';
import Benefits from './components/Benefits';
import UseCases from './components/UseCases';
import Trust from './components/Trust';
import FinalCTA from './components/FinalCTA';
import Navbar from './components/Navbar';

export default function Home() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="bg-[#0a0a0f] text-white min-h-screen">
      <Navbar scrolled={scrolled} />
      <Hero />
      <Problem />
      <Solution />
      <Features />
      <Benefits />
      <UseCases />
      <Trust />
      <FinalCTA />
    </div>
  );
}